var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoryColon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.2,
    height: 28.2,
    viewBox: "0 0 39.2 28.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 121051",
    d: "M8.7 28.2a8.381 8.381 0 01-6.15-2.55A8.381 8.381 0 010 19.5a8.427 8.427 0 01.6-3.25 19.043 19.043 0 011.9-3.35L11.2 0l5.9 3.9-5.1 7.8a8.446 8.446 0 013.8 2.95 7.989 7.989 0 011.5 4.85 8.466 8.466 0 01-2.5 6.15 8.218 8.218 0 01-6.1 2.55zm21.9 0a8.381 8.381 0 01-6.15-2.55 8.381 8.381 0 01-2.55-6.15 8.427 8.427 0 01.6-3.25 19.043 19.043 0 011.9-3.35L33.1 0 39 3.9l-5.1 7.8a8.446 8.446 0 013.8 2.95 7.989 7.989 0 011.5 4.85 8.466 8.466 0 01-2.5 6.15 8.218 8.218 0 01-6.1 2.55z",
    fill: "#0c7eff",
    opacity: 0.2
  })));
}

export default SvgStoryColon;